import { LOCALE_SEARCH_PATHS as P } from 'types/locales';

import type { TFunction } from 'next-i18next';

/**
 * Badge label for a saved search's new-listings count ("8 New"), capped at "99+ New".
 * Returns undefined when there are none, so the card hides the badge.
 *
 * Takes the count of listings added within the window the search's alert
 * frequency covers, not its total match count: a weekly search shows what
 * arrived in the last week. The server derives that window and caches the
 * count, so this is one field on the record rather than a request per card. It
 * is null when alerts are off, leaving no window to count over, and the badge
 * is hidden.
 *
 * Shared by the saved-search panel and the Collections tab, which render the
 * same card. Held here rather than copied into each, because a copy was fed the
 * total match count instead and labelled it "New".
 */
export function newListingsBadgeLabel(count: number | null, t: TFunction): string | undefined {
  if (!count || count <= 0) return undefined;
  const value = count > 99 ? '99+' : String(count);
  return t(P.SAVED_SEARCH_PANEL_NEW_COUNT, { value, defaultValue: `${value} New` });
}
